export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-html5-292dc1f810fb78883e00e645a92b8dea.svg";